exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offline-row {\r\n  position: absolute;\r\n  width:100%;\r\n  top:50%;\r\n\r\n}\r\n\r\n.offline-row p {\r\n  font-size:35px;\r\n  color:#ddd;\r\n}\r\n\r\n@media(max-width:768px){\r\n  .offline-row p {\r\n    font-size:14px!important;\r\n\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/offline/offline.component.css
// module id = ../../../../../src/app/offline/offline.component.css
// module chunks = 2